// biome-ignore-all lint/a11y/useAriaPropsSupportedByRole: shared component anatomy.
// biome-ignore-all lint/a11y/useFocusableInteractive: shared component anatomy.
// biome-ignore-all lint/a11y/noAutofocus: shared component anatomy.
// biome-ignore-all lint/style/useTemplate: shared component anatomy.
// biome-ignore-all lint/complexity/useIndexOf: shared component anatomy.
// biome-ignore-all lint/security/noDangerouslySetInnerHtml: shared component anatomy.
// biome-ignore-all lint/suspicious/noArrayIndexKey: shared component anatomy.
// biome-ignore-all lint/a11y/useSemanticElements: shared component anatomy.
// biome-ignore-all lint/a11y/noInteractiveElementToNoninteractiveRole: shared component anatomy.
// biome-ignore-all lint/a11y/noStaticElementInteractions: shared component anatomy.
// biome-ignore-all lint/a11y/useKeyWithClickEvents: shared component anatomy.
// biome-ignore-all lint/a11y/noSvgWithoutTitle: shared component anatomy.
// biome-ignore-all lint/correctness/useExhaustiveDependencies: shared component anatomy.
"use client";

/**
 * jalco-ui
 * ContributorAvatar
 * by Justin Levine
 * ui.justinlevine.me
 *
 * Client-side avatar with tooltip for the ContributorGrid component.
 */

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@thilke/ui/components/tooltip";
import { formatCount, type GitHubContributor } from "@thilke/ui/lib/github";
import { cn } from "@thilke/ui/lib/utils";
/* eslint-disable @next/next/no-img-element */
import type * as React from "react";

interface ContributorAvatarProps extends React.ComponentProps<"a"> {
  contributor: GitHubContributor;
  avatarClassName?: string;
  imgSize: number;
  showContributions?: boolean;
}

export function ContributorAvatar({
  contributor,
  avatarClassName,
  imgSize,
  showContributions = true,
  className,
  style,
  ...props
}: ContributorAvatarProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <a
          href={contributor.profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          role="listitem"
          aria-label={
            showContributions
              ? `${contributor.login} — ${contributor.contributions} contributions`
              : contributor.login
          }
          data-slot="contributor-avatar"
          className={cn(
            "relative rounded-full outline-none transition-transform hover:z-10 hover:scale-110 focus-visible:z-10 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
            className,
          )}
          style={style}
          {...props}
        >
          <img
            src={`${contributor.avatarUrl}&s=${imgSize * 2}`}
            alt=""
            width={imgSize}
            height={imgSize}
            className={cn(
              "rounded-full border-2 border-background bg-muted",
              avatarClassName,
            )}
            loading="lazy"
          />
        </a>
      </TooltipTrigger>
      <TooltipContent side="bottom" sideOffset={4}>
        <span className="font-medium">{contributor.login}</span>
        {showContributions && (
          <span className="ml-1.5 opacity-60">
            {formatCount(contributor.contributions)} contributions
          </span>
        )}
      </TooltipContent>
    </Tooltip>
  );
}
